import { FC } from 'react';

import { IconProps } from './StatusIcon.interfaces';
import StyledStatusIcon from './StatusIcon.styles';

const StatusIcon: FC<IconProps> = ({ icon, error = false }) => <StyledStatusIcon error={error}>{icon}</StyledStatusIcon>;

export default StatusIcon;
